const AccessDenied403 = (): JSX.Element => (
  <div>
    <h1> Acceso no permitido.</h1>
  </div>
);

export default AccessDenied403;
